var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 162,
    viewBox: "0 0 162 162",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#FAA100",
    opacity: 0.083,
    cx: 80.85,
    cy: 80.85,
    r: 80.85
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FAA100",
    opacity: 0.18,
    cx: 80.85,
    cy: 80.85,
    r: 54.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8 48c16.983 0 30.8 13.816 30.8 30.8s-13.817 30.8-30.8 30.8S50 95.784 50 78.8 63.817 48 80.8 48z",
    fill: "#FAA100",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.75 69.1a1.52 1.52 0 0 1 2.15 2.15L83.15 79l7.75 7.75a1.519 1.519 0 0 1 0 2.15 1.518 1.518 0 0 1-2.15 0L81 81.15l-7.75 7.75a1.52 1.52 0 1 1-2.15-2.15L78.85 79l-7.75-7.75a1.52 1.52 0 1 1 2.15-2.15L81 76.85l7.75-7.75z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFail);
export default __webpack_public_path__ + "static/media/fail.96311d54091ef682212a988f4f34532b.svg";
export { ForwardRef as ReactComponent };